<template>
    <div class="mt-6">
      <v-btn v-if="back" :to="back.to" v-html="back.title" large outlined></v-btn>
      <v-btn v-if="forward" :to="forward.to" v-html="forward.title" class="float-right" large outlined></v-btn>
    </div>
</template>
<script>
export default {
  name: 'bottom-navigation',
  props: {
    back: {
      type: Object,
    },
    forward: {
      type: Object,
    },
  },
}
</script>
